import { BaseModel } from './base-model';

export class ProviderInstanceBaseModel extends BaseModel {
  providerId: string;
  providerInstanceId: string;
}
